import React from 'react';
import AggregateProto from './aggregate-proto';
import {momentRange} from "../../gd/convert/moment-range";

export default class AggregateMoment extends AggregateProto {

    min() {
        if (this.data.length === 0) return null;

        //data should be array of moments
        return _.chain(this.data)
            .minBy(item=>item.format('x'))
            .value();
    }

    max() {
        if (this.data.length === 0) return null;

        //data should be array of moments
        return _.chain(this.data)
            .maxBy(item=>item.format('x'))
            .value()
    }

    range() {
        if (this.data.length === 0) return null;

        //data should be array of moments
        let min = this.data[0], max = this.data[0];
        _.map(this.data, moment=> {
            if (moment.isBefore(min)) min = moment;
            else if (moment.isAfter(max)) max = moment;
        });

        return momentRange(min, max);
    }
}
